import { generateAutomationName } from "../../helpers/generateAutomationName";

import { CREATE_TOPIC_FROM_KW_ITEM_ID, CREATE_TOPICS_ITEM_ID } from "./Dropdown/config";

export const headerKeys = {
    wrapper: generateAutomationName("home", ["topics", "header", "wrapper"]),
    subtitle: generateAutomationName("home", ["topics", "header", "subtitle"]),
    btnGroup: generateAutomationName("home", ["topics", "header", "buttons"]),
};

export const topicKeys = {
    container: generateAutomationName("home", ["topics", "container"]),
    headerWrapper: generateAutomationName("home", ["topics", "header", "container"]),
    filterContainer: generateAutomationName("home", ["topics", "header", "filters", "wrapper"]),
};

export const dropdownKeys = {
    createTopic: generateAutomationName("home", ["topics", "dropdown", "item", CREATE_TOPICS_ITEM_ID]),
    createTopicFromKW: generateAutomationName("home", ["topics", "dropdown", "item", CREATE_TOPIC_FROM_KW_ITEM_ID]),
    text: generateAutomationName("home", ["topics", "dropdown", "item", "text"]),
    maxTooltip: generateAutomationName("home", ["topics", "dropdown", "item", "tooltip"]),
};

export const emptySuggestionsKeys = {
    container: generateAutomationName("home", ["topics", "modal", "empty", "suggested"]),
    text: generateAutomationName("home", ["topics", "modal", "empty", "suggested", "text"]),
};

export const listKeys = {
    container: generateAutomationName("home", ["topics", "list", "container"]),
};

export const monitorBtnKeys = {
    container: generateAutomationName("home", ["topics", "monitor", "button"]),
};

export const topicItemKeys = {
    container: generateAutomationName("home", ["topics", "modal", "item", "topic", "metadata", "container"]),
    name: generateAutomationName("home", ["topics", "modal", "item", "topic", "name"]),
    volume: generateAutomationName("home", ["topics", "modal", "item", "topic", "volume"]),
    btn: generateAutomationName("home", ["topics", "modal", "item", "topic", "select", "button"]),
};
export const sortingKeys = {
    container: generateAutomationName("home", ["topics", "sorting", "container"]),
};
export const suggestedLoaderKeys = {
    item: generateAutomationName("home", ["home", "topics", "modal", "preloader"]),
};
